/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ef8844d1e482d0df633b5b80a6e446f0>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */
export { JiraProductDiscoveryLogo } from './logo';
export { JiraProductDiscoveryLogoCS } from './logo-cs';
export { JiraProductDiscoveryIcon } from './icon';
